import { useState } from 'react'
import { useUploadContext } from '../setup/useUploadContext'

export const useUploadFile = () => {
  const { file, setFile } = useUploadContext()
  const [error, setError] = useState('')
  const [status, setStatus] = useState<'idle' | 'success' | 'progress'>('idle')

  const limitSize = 2 * 1024 * 1024 // 2 MB
  const validTypes = ['image/png', 'image/jpeg', 'image/jpg']

  const handlerChangeFile = (file: File) => {
    if (file && file.size > limitSize) {
      setStatus('idle')
      setError('O tamanho do arquivo excede 2 MB')
      return
    }

    if (!validTypes.includes(file.type)) {
      setStatus('idle')
      setError('Formato inválido')
      return
    }

    setStatus('progress')
    setTimeout(() => {
      setFile(file)
      setStatus('success')
    }, 2000)
  }

  const cleanError = () => setError('')

  const cleanState = () => setFile(null)

  return {
    file,
    handlerChangeFile,
    error,
    cleanError,
    cleanState,
    status,
  }
}
